// extracted by mini-css-extract-plugin
module.exports = {"wrap":"GVav","imgBg":"GVabf","image":"GVob","textBox":"GVabh","title":"GVal","statistic":"GVa5"};